import { useMemo } from 'react'
import { useCurrentBrandPlan } from './queries/brandPlans/useCurrentBrandPlan'
import { useIntegrationHeartbeatStatus } from './useIntegrationHeartbeatStatus'
import { BrandPlanTactic } from 'types'

export const useOutdatedScopeTikTokIntegration = () => {
  const { outdatedScopeTikTokIntegration } = useIntegrationHeartbeatStatus()
  const { data: brandPlan } = useCurrentBrandPlan()

  const isOutdatedScopeTikTokIntegration = useMemo(() => {
    return !!brandPlan?.tactics.includes(BrandPlanTactic.TikTok) && !!outdatedScopeTikTokIntegration
  }, [brandPlan?.tactics, outdatedScopeTikTokIntegration])

  return {
    outdatedScopeTikTokIntegration: isOutdatedScopeTikTokIntegration,
  }
}
